import { render, staticRenderFns } from "./MobileProjectMaterial.vue?vue&type=template&id=158e2b4f&scoped=true"
import script from "./MobileProjectMaterial.vue?vue&type=script&lang=js"
export * from "./MobileProjectMaterial.vue?vue&type=script&lang=js"
import style0 from "./MobileProjectMaterial.vue?vue&type=style&index=0&id=158e2b4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158e2b4f",
  null
  
)

export default component.exports